import { TWifiState } from '~/src/features/wifi/store/types';

export const allCategoriesValue = 'all';

export const initialCategory = {
    value: allCategoriesValue,
    label: 'Все категории',
};

export const initialState: TWifiState = {
    fetching: false,
    fetchError: null,
    items: [],

    selectedContact: null,
    selectedCategory: initialCategory,
};
